import {
  SimpleForm,
  TextInput,
  BooleanInput,
  NumberInput,
  SelectInput,
  ReferenceInput,
  AutocompleteInput,
  required,
  FormDataConsumer,
  Edit,
} from 'react-admin';

const transformData = (data: any) => data;

export const ProductEdit = (props: any) => (
  <Edit {...props} transform={transformData}>
    <SimpleForm>
      <SelectInput
        label="Тип"
        source="type"
        choices={[
          { id: 'all', name: 'All' },
          { id: 'course', name: 'Course' },
          { id: 'feed', name: 'Feed' },
          { id: 'material', name: 'Material' },
          { id: 'digest', name: 'Digest' },
        ]}
        validate={required()}
        fullWidth
      />
      <SelectInput
        label="Длительность"
        source="duration"
        choices={[
          { id: 'month', name: 'Месяц' },
          { id: 'full', name: 'До 31.12.2025' },
        ]}
        validate={required()}
        fullWidth
      />
      <TextInput
        source="name"
        validate={required()}
        label="Название"
        fullWidth
      />
      <NumberInput
        source="price"
        validate={required()}
        label="Цена"
        fullWidth
      />
      <TextInput source="description" multiline label="Описание" fullWidth />
      <TextInput source="link" label="Ссылка" fullWidth />
      <BooleanInput source="is_enable" defaultValue={true} label="Активный" />
      <FormDataConsumer>
        {({ formData, ...rest }) =>
          (formData.type === 'feed' || formData.type === 'course') && (
            <>
              <h3>Рубрика</h3>
              <ReferenceInput
                source="feed_id"
                reference="feeds"
                label="Рубрика"
                fullWidth
              >
                <AutocompleteInput optionText="name" fullWidth />
              </ReferenceInput>
            </>
          )
        }
      </FormDataConsumer>

      <FormDataConsumer>
        {({ formData, ...rest }) =>
          formData.type === 'material' && (
            <>
              <h3>Рубрика</h3>
              <ReferenceInput
                source="material_id"
                reference="materials"
                label="Материал"
                fullWidth
              >
                <AutocompleteInput optionText="name" fullWidth />
              </ReferenceInput>
            </>
          )
        }
      </FormDataConsumer>

      <h3>Спасибо за покупку</h3>
      <TextInput
        source="thanks.title"
        label="Заголовок"
        validate={required()}
        fullWidth
      />
      <TextInput
        source="thanks.text"
        label="Текст"
        multiline
        validate={required()}
        fullWidth
      />

      <h3>Баннер</h3>
      <TextInput
        source="banner.name"
        label="Название"
        validate={required()}
        fullWidth
      />
      <TextInput
        source="banner.description"
        label="Описание"
        multiline
        validate={required()}
        fullWidth
      />
      <TextInput
        source="banner.url"
        label="Ссылка"
        validate={required()}
        fullWidth
      />
      <TextInput
        source="banner.url_mobile"
        label="Ссылка мобильная"
        validate={required()}
        fullWidth
      />
      <TextInput
        source="banner.label"
        label="Метка"
        validate={required()}
        fullWidth
      />
      <TextInput
        source="banner.btn"
        label="Текст кнопки"
        validate={required()}
        fullWidth
      />
    </SimpleForm>
  </Edit>
);
